module.exports = __webpack_public_path__ + "20d99744431738141d42ff91932b4c9c.png";


/*****************
 ** WEBPACK FOOTER
 ** ./webserver/document_root/s/img/mobile/ad/logo2x.png
 ** module id = 3707
 ** module chunks = 100
 **/